const Rules = () => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 text-black">
      <div className="text-xl bg-blue-dark px-10 py-12 rounded-lg space-y-3">
        <h2 className="text-center font-semibold mb-5">
          The Monty Hall Problem
        </h2>
        <p>
          This is an interesting probability problem. Try to solve it yourself,
          or take a look at the answer!
        </p>
        <p>
          The answer may seem shocking or paradoxical, but it is completely
          fair!
        </p>
        <p>
          <a
            className="text-red underline"
            href="https://en.wikipedia.org/wiki/Monty_Hall_problem"
          >
            Monty Hall problem — Wikipedia
          </a>
        </p>
      </div>
      <div className="text-xl flex-1 bg-blue-dark px-10 py-12 rounded-lg">
        <h2 className="text-center font-semibold mb-5">Rules</h2>
        <ul>
          <li>
            - There are three doors in front of you: one winning door and two
            losing doors.
          </li>
          <li>- You must choose one door without opening it.</li>
          <li>
            - After your choice, one door that you did not select and that is
            not the winning door will open.
          </li>
          <li>
            - You can then open the door you originally selected or switch to
            the other closed door.
          </li>
          <br />
          <p>Can you win two out of three games? If so, how?</p>
        </ul>
      </div>
      <div className="text-xl flex-1 bg-blue-dark px-10 py-12 rounded-lg">
        <h2 className="text-center font-semibold mb-5">Legend</h2>
        <ul>
          <li>
            <span className="font-symbol">□</span> - closed door
          </li>
          <li>
            <span className="font-symbol">▣</span> - selected door
          </li>
          <li>
            <span className="text-green font-symbol">■</span> - winning door
          </li>
          <li>
            <span className="text-red font-symbol">▩</span> - losing door
          </li>
        </ul>
      </div>
    </div>
  );
}
export default Rules;
